export default __webpack_public_path__ + "static/person-6f6ace93f7ac6c675a82167f67ca5676.png";